// @ts-nocheck
import { useCallback } from 'react';
import { useResetRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { getAppcues } from 'util/shared';
import { useClearLoginState } from 'hooks/useClearLoginState';
import {
  loginErrorMessageState,
  userDetailsState,
  userDetailsState,
  currentToastState,
  workerState,
} from 'states';

export const useClearLoginState = () => {
  const resetLoginErrorMessage = useResetRecoilState(loginErrorMessageState);
  const setUserDetails = useSetRecoilState(userDetailsState);
  const resetCurrentToast = useResetRecoilState(currentToastState);
  const pollingWorker = useRecoilValue(workerState);

  const clearLoginState = useCallback(() => {
    localStorage.removeItem('sgToken');
    setUserDetails(undefined);
    resetCurrentToast();
    resetLoginErrorMessage();
    getAppcues().reset();
    void pollingWorker?.comLinkWorker?.setAuthHeader({});
  }, [
    resetLoginErrorMessage,
    setUserDetails,
    resetCurrentToast,
    pollingWorker,
  ]);
  return { clearLoginState };
};
